import { Fragment, JSX } from 'react';
import { InView } from 'react-intersection-observer';

import {
  KibAccordionNew,
  KibAccordionNewItem,
} from '@chewy/kib-content-groups-react';

export default function Faq({
  descendants,
  analytics,
  onSectionView,
  title = 'Frequently Asked Questions',
}: {
  title?: string;
  descendants: {
    title: string;
    text?: string | JSX.Element;
    table?: JSX.Element;
    footer?: JSX.Element;
    descendants?: {
      text?: string | JSX.Element;
      suffix?: string | JSX.Element;
    }[];
  }[];
  analytics: {
    label: string;
    value: string;
  };
  onSectionView: (
    label: string,
    value: string,
    extraData?: Record<string, string>,
  ) => void;
}): JSX.Element {
  return (
    <section className="pi-careplus__faq">
      <div className="pi-careplus__faq--content">
        <InView
          as="h2"
          triggerOnce={true}
          onChange={(inView: any) => {
            if (!inView) return;
            onSectionView(analytics.label, analytics.value);
          }}
          className="pi-careplus__faq--title"
        >
          {title}
        </InView>
        <KibAccordionNew className="pi-careplus__faq--cards">
          {descendants.map(
            (
              {
                title,
                text,
                footer,
                descendants,
                table,
              }: {
                title: string;
                text?: string | JSX.Element;
                footer?: string | JSX.Element;
                descendants?: {
                  text?: string | JSX.Element;
                  suffix?: string | JSX.Element;
                }[];
                table?: JSX.Element;
              },
              i: number,
            ) => {
              const name = `pi-careplus__faq--card-${i}`;
              return (
                <KibAccordionNewItem title={title} key={name}>
                  <div className={`pi-careplus__faq--card ${name}`}>
                    {text && <p className="pi-careplus__faq--text">{text}</p>}
                    {descendants && descendants.length && (
                      <ul className="pi-careplus__faq--list">
                        {descendants.map(
                          (
                            {
                              text,
                              suffix,
                            }: {
                              text: string | JSX.Element;
                              suffix: string | JSX.Element;
                            },
                            i: number,
                          ) => {
                            const name = `pi-careplus__faq--listitem-${i}`;
                            return (
                              <Fragment key={name}>
                                {text && (
                                  <li
                                    className={`pi-careplus__faq--listitem ${name}`}
                                  >
                                    <p className="pi-careplus__faq--text">
                                      {text}
                                    </p>
                                  </li>
                                )}
                                {suffix && (
                                  <p className="pi-careplus__faq--suffix">
                                    {suffix}
                                  </p>
                                )}
                              </Fragment>
                            );
                          },
                        )}
                      </ul>
                    )}
                    {table && (
                      <div className="pi-careplus__faq--table">
                        <table>{table}</table>
                      </div>
                    )}
                    {footer && (
                      <p className="pi-careplus__faq--footer">{footer}</p>
                    )}
                  </div>
                </KibAccordionNewItem>
              );
            },
          )}
        </KibAccordionNew>
      </div>
    </section>
  );
}
